"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable react/no-unused-prop-types */
var TooltipFlyout = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(TooltipFlyout, _PureComponent);
  function TooltipFlyout() {
    (0, _classCallCheck2["default"])(this, TooltipFlyout);
    return _callSuper(this, TooltipFlyout, arguments);
  }
  (0, _createClass2["default"])(TooltipFlyout, [{
    key: "render",
    value: function render() {
      var _TooltipFlyout$calcul = TooltipFlyout.calculateProps(this.props),
        children = _TooltipFlyout$calcul.children,
        positionX = _TooltipFlyout$calcul.positionX,
        positionY = _TooltipFlyout$calcul.positionY;
      return /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(".concat(positionX, " ").concat(positionY, ")")
      }, children);
    }
  }], [{
    key: "calculatePosition",
    value:
    //eslint-disable-line

    function calculatePosition(_ref) {
      var anchorX = _ref.anchorX,
        anchorY = _ref.anchorY,
        height = _ref.height,
        isAnchoredX = _ref.isAnchoredX,
        isAnchoredY = _ref.isAnchoredY,
        plotHeight = _ref.plotHeight,
        plotWidth = _ref.plotWidth,
        width = _ref.width;
      var midX = plotWidth / 2;
      var midY = plotHeight / 2;
      var xPadding = 10;
      var plotAreaPadding = 10;

      /**
       * If Tooltip is anchored in a dimension, it should not follow the mouse, but
       * rather anchor itself in that dimension to it's anchor value... usually this
       * will be based off the position of the data point being hovered. This allows us
       * to reuse the same tooltip logic for various different chart types.
       */
      var positionX = isAnchoredX && !isNaN(anchorX) ? anchorX : plotWidth - plotAreaPadding;
      var positionY = isAnchoredY && !isNaN(anchorY) ? anchorY : plotAreaPadding;

      /**
       * We offset the tooltip from the position before we return so that it is
       * not rendered too close to the edge of the plot area (and gets clipped)
       */
      switch (true) {
        /** First Quadrant */
        case positionX >= midX && positionY < midY:
          return {
            x: positionX - (width + xPadding),
            y: positionY
          };
        /** Third Quadrant */
        case positionX < midX && positionY >= midY:
          return {
            x: positionX + xPadding,
            y: positionY - height
          };
        /** Fourth Quadrant */
        case positionX >= midX && positionY >= midY:
          return {
            x: positionX - (width + xPadding),
            y: positionY - height
          };
        /** Second Quadrant */
        default:
          return {
            x: positionX + xPadding,
            y: positionY
          };
      }
    }
  }, {
    key: "calculateProps",
    value: function calculateProps(props) {
      var position = TooltipFlyout.calculatePosition(props);
      return _objectSpread(_objectSpread({}, props), {}, {
        positionX: position.x,
        positionY: position.y
      });
    }
  }]);
  return TooltipFlyout;
}(_react.PureComponent);
var _default = exports["default"] = TooltipFlyout;
//# sourceMappingURL=TooltipFlyout.js.map